import { configureStore } from '@reduxjs/toolkit';

import globalSlice from './globalSlice';
import userSlice from './userSlice';
import bookingSlice from './bookingSlice';
import questionnaireSlice from './questionnaireSlice';
import taskSlice from './taskSlice';

export const store = configureStore({
    reducer: {
        user: userSlice,
        global: globalSlice,
        booking: bookingSlice,
        questionaire: questionnaireSlice,
        task: taskSlice,
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch